import { Injectable } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ECountrycode } from './enum';

@Injectable({
    providedIn: 'root'
})

export class CommonCalculatorService {
    
  private clickTimeout: any;
  
    //** roundToDecimalPlace **//
    // round 'value' to specified decimal places 'noOfDecimal'
    // this method could also be used to mitigate js/ts floating value calculation or processing error
    roundToDecimalPlace(value: number, noOfDecimals: number) { // to round Away From Zero logic
        const factor = Math.pow(10, noOfDecimals);
        const temp = value * factor + Number.EPSILON;
        const test = Math.round((temp + Number.EPSILON) * 100) / 100;
        return Math.floor(test + 0.5) / factor;
    }

    setZipCodeValidator(countryCode: number, zipControl) {
        if (!zipControl) return;
        zipControl.clearValidators();
        switch (countryCode) {
            case ECountrycode.US: // US
            zipControl.setValidators([
                Validators.required,
                Validators.maxLength(10),
                Validators.pattern(/^\d{5}(?:-\d{4})?$/)
            ]);
            break;
            case ECountrycode.CA: // Canada
            zipControl.setValidators([
                Validators.required,
                Validators.maxLength(10),
                Validators.pattern(/^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/i)
            ]);
            break;
            default: // Any other country
            zipControl.setValidators([Validators.required, Validators.maxLength(10)]);
            break;
        }
        zipControl.updateValueAndValidity();
    }
    
    allowOnlyFaxChars(event: KeyboardEvent) {
        this.allowInputPattern(event, /^[0-9+\-\s().]$/);
    }

    allowOnlyTelephoneChars(event: KeyboardEvent) {
        this.allowInputPattern(event, /^[0-9+\-\s]$/);
    }

    allowInputPattern(event: KeyboardEvent, allowedPattern: RegExp) {
        const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
        if (allowedKeys.includes(event.key)) {
        return;
        }
        if (!allowedPattern.test(event.key)) {
        event.preventDefault();
        }
    }
    
    trimFormGroup(form: FormGroup | FormArray): void {
        Object.keys(form.controls).forEach(key => {
            const control = form.get(key);
            if (control instanceof FormControl) {
                if (typeof control.value === 'string') {
                    const trimmed = control.value.trim();
                    if (control.value !== trimmed) {
                        control.setValue(trimmed, { emitEvent: false });
                    }
                }
            } else if (control instanceof FormGroup || control instanceof FormArray) {
                this.trimFormGroup(control);
            }
        });
    }
    
    numberOnlyWithNegative(event): boolean {
        const inputValue = event.target.value;
        const charCode = (event.which) ? event.which : event.keyCode;
        const currentCursorPosition = event.target.selectionStart;
        const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
        // Allow minus sign only at position 0 and only if not already present
        if (charCode == 45) {
            const alreadyHasMinus = inputValue.includes('-');
            const allSelected = currentSelectionLength === inputValue.length;
            if (!alreadyHasMinus && (currentCursorPosition === 0 || allSelected)) {
                return true;
            }
            return false;
        }
        // Delegate the rest to the standard handler
        return this.numberOnly(event);
    }

    numberOnly(event): boolean {
        const inputValue = event.target.value;
        const charCode = (event.which) ? event.which : event.keyCode;
        const currentCursorPosition = event.target.selectionStart;
        const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
        // Check if the input value is "$0.00"
        if (charCode == 45) {
        return false;
        }
        if (currentSelectionLength === inputValue.length) {
        return true;
        }
        if (inputValue === '$0.00') {
        // Set the cursor position after the "$" sign
        event.target.setSelectionRange(1, 1);
        return true; // Allow further input
        }
        // Check if the "$" sign is present in the current value
        const hasDollarSign = inputValue.includes('$');
        // Check if the cursor position is after the "$" sign
        const hasDollarSignBeforeCaret = inputValue.slice(0, currentCursorPosition).includes('$');
        // If the cursor is not after the "$" sign and "$" sign is present, prevent input
        if (!hasDollarSignBeforeCaret && hasDollarSign && charCode !== 46 && (charCode < 48 || charCode > 57)) {
        return false;
        }
        // If the entered character is a dot and there's already a dot in the input, prevent input
        if (charCode == 46 && inputValue.includes('.') && inputValue.indexOf('.') !== currentCursorPosition) {
        return false;
        }
        if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode === 47)) {
        return false;
        }
        return true; // Allow input
    }

    getActualAmountFromInp(value: any): number {
        if (value == null) return 0;
        try {
        const valStr = value.toString();
        if (valStr.includes('(') && valStr.includes(')')) {
            return -1 * parseFloat(valStr.replace(/[^0-9.-]/g, ''));
        } else {
            return parseFloat(valStr.replace(/[^0-9.-]/g, ''));
        }
        } catch (err) {
        console.warn('Error in getActualAmountFromInp:', value, err);
        return 0;
        }
    }

    handledblClick(event: any) {
        clearTimeout(this.clickTimeout);

        const inputElement = event.target as HTMLInputElement;
        inputElement.select(); // Select the entire text on double-click
    }

    handleClick(event: any) {
        // Get the current value of the input field
        let currentValue: string = event.target.value;
        const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
        const inputElement = event.target as HTMLInputElement;
        const inputValue = inputElement.value;
        clearTimeout(this.clickTimeout);
        this.clickTimeout = setTimeout(() => {
        if (inputValue === '$0.00') {
            const selectionLength = inputElement.selectionEnd - inputElement.selectionStart;
            // If the entire text is not selected, set the cursor position after the "$" sign
            if (selectionLength !== inputValue.length) {
            inputElement.setSelectionRange(1, 1);
            }
        }
        }, 200); // Delay to check for double click

        if (currentSelectionLength === currentValue.length) {
        return true;
        }
        // Check if the input value is "$0.00"
        if (currentValue === '$0.00') {
        // Set the cursor position after the "$" sign
        event.target.setSelectionRange(1, 1);
        return;
        }

        // Check if the "$" sign is present in the current value
        const hasDollarSign = currentValue.includes('$');
        // Get the cursor position
        const caretPosition = event.target.selectionStart;
        // Check if the cursor position is after the "$" sign
        const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
        // If the cursor is not after the "$" sign, adjust the cursor position
        if (!hasDollarSignBeforeCaret && hasDollarSign) {
        // Find the index of "$" sign
        const dollarSignIndex = currentValue.indexOf('$');
        // Set the cursor position after the "$" sign
        event.target.setSelectionRange(dollarSignIndex + 1, dollarSignIndex + 1);
        }
    }
}